import type { Order } from "../../../../../../../services";

const cellProcessing = (item: Order.Model["checkCard"]): string =>
	item?.check?.additionalFields?.checkValue ?? "";

export default cellProcessing;
